export const CONTINENTS: any[] = [
  {
    name: "Europe",
    id: "europe",
    flag: "eu",
    partnerUniversities: "115",
    doubleDegree: "19",
    tripleDegree: null,
    studentsExchanged: "900+",
    internship: "1,300+",
    jobCount: "4",
    jobCities: "Benelux, UK&Ireland, France, Germany&Switzerland",
    inCompanyTraining: "25",
    alumni: "111,000~",
    states: [
      {
        name: "Benelux",
        id: "benelux",
        coordinates: [50.630779, 5.62246],
        flag: "benelux",
        videoUrl: "https://player.vimeo.com/video/344115836",
        legislature: "Constitutional monarchy",
        memberStates: "Belgium, The Netherlands, Luxembourg",
        administrativeCenter: "Brussels, Amsterdam, Luxembourg",
        gdpPerCapita: "USD 48,359",
        population: "28.5 million",
        workingIn: `
<p>Benelux is home to a range of major International Organizations, NGOs, lobbying consultancy firms and Think Tanks. In addition to Brussels, the main center of the EU institutions, also Luxembourg and The Hague play a crucial role in the field of international affairs. While the EU financial and legal institutions, such as the European Investment Bank and the European Court of Justice, are based in Luxembourg, The Hague hosts The International Court of Justice, as well as foreign embassies in the Netherlands. </p>

<p>But Benelux is not just about international affairs. Thanks to its strategic position at the heart of Europe, a large number of multi-national companies have their regional and global HQs here. In particular The Netherlands boasts 14 Fortune Global 500. Luxembourg is instead known for being one of the main financial centers worldwide and ranks second in the field of investment fund, just behind New York. </p>



`,
        workingLanguages: ["French", "Dutch", "German", "Luxembourgeoise"],
        mainLanguage: `<b>English</b> is widely used in professional settings in all three countries.

`,
        internationalCommunities: `Thanks to its dynamic labor market and multicultural nature, a high number of foreigners live in Benelux, as compared to the other EU member states. In Belgium, around 15% of the total population is foreigner (with a peak of 50% in Brussels), while in The Netherlands around 20% of the population comes from abroad. In Luxembourg, foreign residents make up almost half of the total population – with around 65% of people employed in Luxembourg City being foreigner – more than in any other EU country.`,
        do: [
          "Present your business card upon meeting. Business cards in English are accepted.",
          "Accept any drink offered by your host.",
          "Clothing is rather formal, not extremely high fashion, but elegant in a more traditional sense (this is particularly true in Belgium and Luxembourg).",
          "Business decisions are taken using the Polder Model, a consensus decision-making approach based on the recognition of the different positions of all the stakeholders."
        ],
        donts: [
          "Don't be late: punctuality is very important. Call and explain why if you are late.",
          "Don't keep your hands in your pockets during a conversation, as this is considered inappropriate.",
          "Don’t point with your finger, as this is considered ill-mannered.",
          "Don’t discuss personal matters or cultural divisions. People from Benelux are relatively open and enjoy having engaging  discussions. It is, however, a good idea to avoid speaking about topics such as politics."
        ],
        partnerUniversities: "11",
        partnerUniversitiesAdditionalInfos: true,
        bocconiJobsAbroad: "1",
        inCompanyTraining: "5",
        studentsExchanged: "140+",
        internshipPlacement: "250+",
        bocconiAlumni: "1,450+",
        links: [
          {
            title: "JobGate",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/meet+the+employers/find+your+opportunities/jobgate",
            description:
              "the Bocconi online platform, updated daily by employers, with internship and placement opportunities."
          },
          {
            title: "Bocconi&Jobs abroad",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/meeting+employers+and+appllying/bocconi_jobs+abroad/digital+bocconiandjobs+abroad+benelux",
            description:
              "the career event to meet international employers offering opportunities in Benelux."
          },
          {
            title: "In-Company Training abroad",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/employment+guidance/in-company+training/in-company+training_new_mainetti+2010+11+03+03+29",
            description:
              "a short career program designed by Bocconi in partnership with selected companies and institutions."
          },
          {
            title: "One-to-One Advice on the International Job Market",
            link:
              "https://www.unibocconi.it/wps/wcm/connect/bocconi/sitopubblico_it/albero+di+navigazione/home/corsi+di+studio/studenti+iscritti/servizi/career+services/studenti+e+laureati/orientarsi+al+lavoro/one-to-one+advice+on+the+international+job+market",
            description: "personal guidance on the job market in Benelux."
          },
          {
            title: "GoinGlobal",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/employment+guidance/onlineresources_infopoint",
            description:
              "over 3,000 pages with internship and job offers, company profiles, information about residence permits, details about jobs and salaries (only through your yoU@B)."
          },
          {
            title: "Lavoro.net",
            link:
              "https://www.unibocconi.it/wps/wcm/connect/bocconi/sitopubblico_it/albero+di+navigazione/home/corsi+di+studio/studenti+iscritti/servizi/career+services/studenti+e+laureati/orientarsi+al+lavoro/career+service+infopoint/online+resources/lavoro.net?lang=it",
            description: "a list of useful websites for your job search."
          },
          {
            title: "INTERNATIONAL SOS",
            link:
              "https://www.internationalsos.com/MasterPortal/default.aspx?content=messages&countryid=107",
            description:
              "travel safely in Belgium, The Netherlands and Luxembourg."
          }
        ]
      },
      {
        name: "France",
        id: "france",
        coordinates: [46.227638, 2.213749],
        flag: "fr",
        videoUrl: "https://player.vimeo.com/video/344116009",
        legislature: "Republic",
        administrativeCenter: "Paris",
        gdpPerCapita: "USD 39,932",
        population: "64.8 million",
        workingIn: `
        <p>The French economy is well diversified among all sectors: services, finance, commerce, fashion and agriculture, as well as pharmaceutical/chemical, automotive, energy, wine production, export and tourism.</p>
<p>The Paris region is the leading hub, offering an international working environment in both prestigious luxury “Maisons” and International Organizations. Being a top tourist destination, arts, culture and all related businesses represent one of its most valuable assets.</p>
<p>Lyon, home of Interpol, the International Agency for Research on Cancer and Euronews, links Paris to Southern France, the Swiss Alps, Italy, and Spain. Ranking among the most livable cities worldwide, it is a major center for services, transportation, chemical and pharmaceutical industries, as well as biotech and startups.</p>
<p>Strasbourg, the second most important French city in the banking sector, is a cosmopolitan center and one of the most important diplomatic emplacements in the world. The high-speed rail links and the fast-paced development of technology-driven sectors and startups are boosting other cities’ (Montpellier, Nantes, Bordeaux and Toulouse) growth as living and working destinations.</p>

`,
        workingLanguages: ["English", "German", "Spanish", "Italian"],
        mainLanguage: `<b>French</b> is the official and the working language.

`,
        internationalCommunities: `Long a country of immigration, France became a multiethnic society after World War II. Foreigners represent over 6% of
  the French population, while those who were born in another country and have acquired the French citizenship count for
  9%. Paris and its metropolitan area are one of the most multicultural ones in Europe: 20% of residents in the municipality
  of Paris were born outside France.`,
        do: [
          `Polite manners are highly regarded and crucial for making a good impression. Add Monsieur/Madame when meeting someone for the first time and in formal settings.`,
          `When meeting someone, a brisk, light handshake is always appropriate. Friends and close people usually air kiss. This ritual is called faire la bise. In most of France, one kisses each cheek once.`,
          `Expect questions and interruptions during meetings, as this is not considered inappropriate. The French appreciate
    discussion and need an exchange of information before making decisions.`,
          `Take advantage of any networking opportunity, within and outside the working environment. Strong personal
    relationships are a prerequisite to succeed.`
        ],
        donts: [
          `Don't be late: punctuality is important. However, the French may be indulgent and show flexibility if you are some
  minutes late, have good reasons and call to inform.`,
          `Don't speak loudly and gesture too much.`,
          `Don’t ask personal questions or questions like “Where are you from?” to investigate the person’s ethnicity. The culture of assimilation is crucial in France.`,
          `Don’t use high-pressure approaches. Decisions are rarely taken on the first meeting or by the persons at the table and
  require an appropriate exchange of information.`
        ],
        partnerUniversities: "18",
        partnerUniversitiesAdditionalInfos: true,
        bocconiJobsAbroad: "1",
        inCompanyTraining: "4",
        studentsExchanged: "200",
        internshipPlacement: "130+",
        bocconiAlumni: "1,800+",
        links: [
          {
            title: "JobGate",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/meet+the+employers/find+your+opportunities/jobgate",
            description:
              "the Bocconi online platform, updated daily by employers, with internship and placement opportunities."
          },
          {
            title: "Bocconi&Jobs abroad",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/meeting+employers+and+appllying/bocconi_jobs+abroad/digital+bocconiandjobs+abroad+france+and+switzerland,+9+february+2021",
            description:
              "the career event to meet international employers offering opportunities in France."
          },
          {
            title: "In-Company Training abroad",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/employment+guidance/in-company+training/in-company+training_new_mainetti+2010+11+03+03+29",
            description:
              "a short career program designed by Bocconi in partnership with selected companies and institutions."
          },
          {
            title: "One-to-One Advice on the International Job Market",
            link:
              "https://www.unibocconi.it/wps/wcm/connect/bocconi/sitopubblico_it/albero+di+navigazione/home/corsi+di+studio/studenti+iscritti/servizi/career+services/studenti+e+laureati/orientarsi+al+lavoro/one-to-one+advice+on+the+international+job+market",
            description: "personal guidance on the job market in France."
          },
          {
            title: "GoinGlobal",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/employment+guidance/onlineresources_infopoint",
            description:
              "over 3,000 pages with internship and job offers, company profiles, information about residence permits, details about jobs and salaries (only through your yoU@B)."
          },
          {
            title: "Lavoro.net",
            link:
              "https://www.unibocconi.it/wps/wcm/connect/bocconi/sitopubblico_it/albero+di+navigazione/home/corsi+di+studio/studenti+iscritti/servizi/career+services/studenti+e+laureati/orientarsi+al+lavoro/career+service+infopoint/online+resources/lavoro.net?lang=it",
            description: "a list of useful websites for your job search."
          },
          {
            title: "INTERNATIONAL SOS",
            link:
              "https://www.internationalsos.com/MasterPortal/default.aspx?content=messages&countryid=133",
            description: "travel safely in France."
          }
        ]
      },
      {
        name: "Germany",
        id: "germany",
        coordinates: [51.165691, 10.451526],
        flag: "ger",
        videoUrl: "https://player.vimeo.com/video/344116537",
        legislature: "Republic",
        administrativeCenter: "Berlin",
        gdpPerCapita: "USD 44,769",
        population: "82.7 million",
        workingIn: `<p>Germany is divided into 16 “Länder” (states), each of which has its own capital and constitution and remains fairly autonomous. The state of North Rhein-Westfalia was famously known as the land of “coal and steel” in the 1950s and 1960s. Its capital city is Düsseldorf and the economy is mainly driven by manufacturers. Bavaria is the largest German state whose capital and largest city is Munich. Many large automotive companies have their headquarters in the state. The economy of Baden-Württemberg is dominated by small and medium-sized enterprises. </p>
<p>In terms of sectors, the heavy industry is strongly present in the South, Frankfurt is the financial HQs (the European Central Bank is based here), Berlin is the city of innovation, art and entrepreneurial activities (startups), and Hamburg has a prominent role in logistics because it is Europe third- largest port. </p>
<p>German economy has also been supported by industries that have found a niche in the world’s markets.</p>
`,
        workingLanguages: [],
        mainLanguage: `<b>German</b> is the official and the working language.<br><b>English</b> is the working language in the Berlin area and can be considered a plus in multinational companies.
`,
        internationalCommunities: `Germany, among all the European Union states, has the highest percentage of immigrants. Most immigrants come from Turkey, Russia, Poland and Italy. Germany is the second most popular destination for immigrants in the world after the United States. The German government has encouraged immigration over the past fifty years - partly to address longer-term demographic issues in Germany, such as its low birth rate, and partly to address shorter-term labor deficits.
`,
        do: [
          `Learn German before you go job hunting in Germany!`,
          `Be punctual: punctuality is common practice in Germany. Being on time is an important part of social etiquette.`,
          `Shake hands firmly and introduce yourself.`,
          `Send complete applications. In Germany, candidates collect their application documents in a special folder that should include a cover letter, the CV (with photo), certificates, and reference letters.`
        ],
        donts: [
          `Don’t get easily offended: workplace (and often everyday) communication in Germany is direct and to the point. `,
          `Don’t get too personal at the workplace. Germans believe in a clear distinction between work and personal lives, and that includes discussing intimate details.`,
          `Don’t talk about money:  speaking with your colleagues about how much you earn is one of the biggest taboos at work.`,
          `Don’t change plans suddenly: when it comes to business matters, Germans do not like the unexpected!`
        ],
        partnerUniversities: "11",
        partnerUniversitiesAdditionalInfos: true,
        bocconiJobsAbroad: "1",
        inCompanyTraining: "5",
        studentsExchanged: "100+",
        internshipPlacement: "190+",
        bocconiAlumni: "1,650+",
        links: [
          {
            title: "JobGate",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/meet+the+employers/find+your+opportunities/jobgate",
            description:
              "the Bocconi online platform, updated daily by employers, with internship and placement opportunities."
          },
          {
            title: "Bocconi&Jobs abroad",
            link: "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/meeting+employers+and+appllying/bocconi_jobs+abroad/digital+bocconiandjobs+abroad+germany",
            description:
              "the career event to meet international employers offering opportunities in Germany."
          },
          {
            title: "In-Company Training abroad",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/employment+guidance/in-company+training/in-company+training_new_mainetti+2010+11+03+03+29",
            description:
              "a short career program designed by Bocconi in partnership with selected companies and institutions."
          },
          {
            title: "One-to-One Advice on the International Job Market",
            link:
              "https://www.unibocconi.it/wps/wcm/connect/bocconi/sitopubblico_it/albero+di+navigazione/home/corsi+di+studio/studenti+iscritti/servizi/career+services/studenti+e+laureati/orientarsi+al+lavoro/one-to-one+advice+on+the+international+job+market",
            description: "personal guidance on the job market in Germany."
          },
          {
            title: "GoinGlobal",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/employment+guidance/onlineresources_infopoint",
            description:
              "over 3,000 pages with internship and job offers, company profiles, information about residence permits, details about jobs and salaries (only through your yoU@B)."
          },
          {
            title: "Lavoro.net",
            link:
              "https://www.unibocconi.it/wps/wcm/connect/bocconi/sitopubblico_it/albero+di+navigazione/home/corsi+di+studio/studenti+iscritti/servizi/career+services/studenti+e+laureati/orientarsi+al+lavoro/career+service+infopoint/online+resources/lavoro.net?lang=it",
            description: "a list of useful websites for your job search."
          },
          {
            title: "INTERNATIONAL SOS",
            link:
              "https://www.internationalsos.com/MasterPortal/default.aspx?content=messages&countryid=138",
            description: "travel safely in Germany."
          }
        ]
      },

      {
        name: "Scandinavia",
        id: "scandinavia",
        coordinates: [60.472023, 8.468946],
        flag: "scandinavia",
        videoUrl: "https://vimeo.com/338860173/844de66267",
        legislature: "Constitutional monarchy",
        memberStates: "Denmark, Norway, Sweden",
        administrativeCenter: "Copenhagen, Oslo, Stockholm",
        gdpPerCapita: "USD 59,432",
        population: "21.2 million",
        workingIn: `<p>The Nordic economies have had some of the best macroeconomic performance in the past ten years among the countries in the Western World. </p>
<p>While privately owned firms are responsible for the highest economic output in Sweden, the public sector is its largest employer. Municipal and county councils represent a large portion of the overall labor market and they commonly offer positions in the healthcare as well as the educational sectors. Moreover, Sweden is one of the countries at the forefront of clean technologies and eco-friendly applications. </p>
<p>Denmark has a thoroughly modern market economy that features a high-tech agricultural sector, state-of-the-art manufacturing with world-leading firms in pharmaceuticals, maritime shipping and renewable energy, and a high dependence on foreign trade. The Danish design, architecture and fashion are well known around the globe. </p>
<p>The Norwegian economy is a prosperous mixed economy, with a vibrant private sector, a large state sector, and an extensive social safety net. The government controls key areas, such as the vital oil sector, through extensive regulation and large-scale state-owned enterprises.</p>`,
        workingLanguages: ["Danish", "Norwegian", "Swedish"],
        businessPracticeInternational: true,
        mainLanguage: `<b>English</b> is widely used in professional settings in all three countries.
`,
        internationalCommunities: `The Scandinavian culture is egalitarian and the workplace is merit-based. For the majority of companies in Sweden, the
  business structure is horizontal and functional. Managers expect employers to demonstrate self-initiative and approach
  them only when necessary. The Danish workplace culture is characterized by, among others: flat hierarchy; teamworking;
  flexible working hours; a proactive and informal communication style. Norway is very non-hierarchical in its approach to
  business structure. The Scandinavian countries are rated among the best places in the world for work-life balance.`,
        do: [
          `Scandinavians respect punctuality. Be on time for all business and social appointments.`,
          `Maintaining eye contact during introductions and any conversation is considered polite, as it denotes interest and
  alertness.`,
          `Conservative attire is appropriate, especially in Sweden. For business appointments men should wear suits and ties,
  women suits or dresses.`,
          `Scandinavians are rather reserved in public. Avoid talking loudly or gesticulating wildly.`
        ],
        donts: [
          `Don’t schedule business trips to Scandinavia in July and August when most people take vacations.`,
          `Scandinavians appreciate plenty of personal space around them. Avoid physical contact with anyone except close friends.`,
          `Don’t bring gifts at a meeting. Anti-bribery legislation makes it not appropriate in a business setting.`,
          `Don’t talk with your hands in your pockets, as it is considered too casual.
`
        ],
        partnerUniversities: "10",
        partnerUniversitiesAdditionalInfos: true,
        studentsExchanged: "160+",
        internshipPlacement: "20~",
        bocconiAlumni: "470+",
        links: [
          {
            title: "JobGate",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/meet+the+employers/find+your+opportunities/jobgate",
            description:
              "the Bocconi online platform, updated daily by employers, with internship and placement opportunities."
          },
          {
            title: "One-to-One Advice on the International Job Market",
            link:
              "https://www.unibocconi.it/wps/wcm/connect/bocconi/sitopubblico_it/albero+di+navigazione/home/corsi+di+studio/studenti+iscritti/servizi/career+services/studenti+e+laureati/orientarsi+al+lavoro/one-to-one+advice+on+the+international+job+market",
            description: "personal guidance on the job market in Scandinavia."
          },
          {
            title: "GoinGlobal",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/employment+guidance/onlineresources_infopoint",
            description:
              "over 3,000 pages with internship and job offers, company profiles, information about residence permits, details about jobs and salaries (only through your yoU@B)."
          },
          {
            title: "Lavoro.net",
            link:
              "https://www.unibocconi.it/wps/wcm/connect/bocconi/sitopubblico_it/albero+di+navigazione/home/corsi+di+studio/studenti+iscritti/servizi/career+services/studenti+e+laureati/orientarsi+al+lavoro/career+service+infopoint/online+resources/lavoro.net?lang=it",
            description: "a list of useful websites for your job search."
          },
          {
            title: "INTERNATIONAL SOS",
            link:
              "https://www.internationalsos.com/MasterPortal/default.aspx?content=messages&countryid=127",
            description: "travel safely in Denmark, Norway and Sweden."
          }
        ]
      },
      {
        name: "Spain",
        id: "spain",
        coordinates: [40.463669, -3.74922],
        flag: "es",
        videoUrl: "https://player.vimeo.com/video/344116194",
        legislature: "Constitutional monarchy",
        administrativeCenter: "Madrid",
        gdpPerCapita: "USD 28,358",
        population: "46.3 million",
        workingIn: `<p>Spain is the second most visited destination worldwide by tourists arrivals. This makes the tourism industry an important economic driver in the country, accounting for about 11% of the annual national GDP. The prominence of Spain in the global tourism industry is witnessed by the presence of the World Tourism Organization HQs in Madrid.</p>
<p>Pharmaceuticals and automobiles are the primary export commodities from Spain’s manufacturing industry. Spain is Europe’s second-largest automobile manufacturer, and it hosts many global automobile manufacturing giants.</p>
<p>Another crucial industry in Spain is energy production. Even if the country relies heavily on fossil fuels in its energy consumption, in the last years it has massively invested in renewable sources. Spain has the world’s largest solar industry, and it made history for being the pioneering country to have wind power as its primary energy source for a whole year in 2013.</p>
<p>Infrastructure development represents another important pillar of the Spanish economy. The country has strongly been investing in infrastructure and it now has Europe’s longest high-speed rail network.</p>`,
        workingLanguages: ["English"],
        mainLanguage: `<b>Castilian Spanish</b> is the official language and the working language.<br>Other languages with official status are: <b>Catalan</b>, <b>Galician</b> and <b>Basque<b>.

`,
        internationalCommunities: `An improving Spanish economy led to a demographic boom in Madrid in the late 1990s and the early 21st century with international immigration. Madrid has long attracted immigrants from around the world. Nearly 84% of the city's population are Spaniards, while those of other origins – most of them from South America and other EU countries – account for more than 16% of the population. In Barcelona, 62% of the inhabitants were born in Catalonia, while almost 21% come from other areas of Spain. Over 17% of the residents are international.

`,
        do: [
          `Care for your network. In Spain, many people find work through informal routes such as word-of-mouth, personal contacts
  and speculative applications, especially in small to medium-sized companies.`,
          `Present your business card upon meeting. They should contain your first name and surname, job title, but no academic
  titles. Having one side of your card translated into Spanish generally leaves a good
  impression.`,
          `Business attire is classic, professional and conventional. Suits usually come in dark colors, although lighter colors are not
  necessarily to be avoided.`,
          `Use both first names. If your Spanish counterparts have two first names, you should use both when addressing them (e.g. Jose Luis or Maria Teresa).
`
        ],
        donts: [
          `Don’t be late. Even if people’s concept of time and punctuality in Spain is not the same as in other Western nations, do not
  assume you can show up whenever you like without anyone noticing.`,
          `Don’t schedule meetings between 2 and 4 pm. Siestas do not really exist in business culture anymore, but these are the
  hours when workers normally take lunch breaks that often last a good two hours.`,
          `Don’t avoid social occasions. You are expected to build up personal
  relationships and trust – usually through lunches, coffee breaks and other social gatherings – with colleagues and
  business counterparts.`,
          `Don’t approach directly those above your rank. In Spain, most companies are still hierarchical. If any issues arise, seek
  help from your superior.`
        ],
        partnerUniversities: "8",
        partnerUniversitiesAdditionalInfos: true,
        studentsExchanged: "90+",
        internshipPlacement: "55+",
        bocconiAlumni: "500+",
        links: [
          {
            title: "JobGate",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/meet+the+employers/find+your+opportunities/jobgate",
            description:
              "the Bocconi online platform, updated daily by employers, with internship and placement opportunities."
          },
          {
            title: "One-to-One Advice on the International Job Market",
            link:
              "https://www.unibocconi.it/wps/wcm/connect/bocconi/sitopubblico_it/albero+di+navigazione/home/corsi+di+studio/studenti+iscritti/servizi/career+services/studenti+e+laureati/orientarsi+al+lavoro/one-to-one+advice+on+the+international+job+market",
            description: "personal guidance on the job market in Spain."
          },
          {
            title: "GoinGlobal",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/employment+guidance/onlineresources_infopoint",
            description:
              "over 3,000 pages with internship and job offers, company profiles, information about residence permits, details about jobs and salaries (only through your yoU@B)."
          },
          {
            title: "Lavoro.net",
            link:
              "https://www.unibocconi.it/wps/wcm/connect/bocconi/sitopubblico_it/albero+di+navigazione/home/corsi+di+studio/studenti+iscritti/servizi/career+services/studenti+e+laureati/orientarsi+al+lavoro/career+service+infopoint/online+resources/lavoro.net?lang=it",
            description: "a list of useful websites for your job search."
          },
          {
            title: "INTERNATIONAL SOS",
            link:
              "https://www.internationalsos.com/MasterPortal/default.aspx?content=messages&countryid=170",
            description: "travel safely in Spain."
          }
        ]
      },
      {
        name: "Switzerland",
        id: "switzerland",
        coordinates: [46.818188, 8.227512],
        flag: "sw",
        videoUrl: "https://player.vimeo.com/video/344124083",
        legislature: "Republic",
        administrativeCenter: "Zurich",
        gdpPerCapita: "USD 80,637",
        population: "8.4 million",
        workingIn: `<p>With one of the highest GDPs in the world, Switzerland is an attractive work destination for foreign professionals. Its three main sectors are services, industry and trade, and the primary sector. Most of the opportunities for young graduates are in banking and pharmaceutical sectors, in large manufacturing multinationals and in international organizations and NGOs.</p>
<p>The finance sector is concentrated in the Zurich area. Its main activities are wealth management and private banking, though the largest international banks operate in all main financial areas. Life sciences companies are mainly located in the so-called “BioValley” region of Basel and in Zurich. In the French-speaking area, two other sectors are particularly relevant: luxury and commodity trading. Switzerland also hosts around 250 NGOs that have consultative status with the UN. Most of them are based in Geneva.</p>
<p>The Swiss business landscape is dominated by small and medium enterprises, but multinational corporations account for a third of the overall GDP. Many European companies are opening their global headquarters in the country, and US firms their regional ones.</p>
`,
        workingLanguages: ["German", "French", "Italian "],
        mainLanguage: `<b>English</b> is widely used in professional settings.
`,
        internationalCommunities: `Since the unemployment rate is very low, the country has strong needs for resources and looks for them outside Switzerland. Foreign nationals make up nearly a third of the workforce, mainly from the EU, including foreign and cross-border workers. This is mainly due to the extensive borders, with a wide range of external influences at play here.`,
        do: [
          `Dress conservatively, especially in business meetings. The dress code can be more informal in the office.`,
          `Shake hands with everyone present at business and social meetings, also when leaving, but wait to be introduced by a
  third person.`,
          `Present your business card upon meeting. Even if a translation of one side into the local language would be ideal,
  business cards in English are acceptable.`,
          `Always use the formal “Sie/Vous/Lei” and the last name of the other person, unless specifically invited to do
  otherwise. First names are seldom used in a business setting.`
        ],
        donts: [
          `Don't be late: Swiss are well renowned for their punctuality in both business and social events. Call with an
  explanation if you are late.`,
          `Don’t ask personal questions. Swiss are very discreet and reserved.`,
          `Don’t keep your hands in your pockets during a conversation. It is considered impolite, such as gum chewing and pointing with your fingers.`,
          `Don’t bring gifts at a meeting as it is not normally part of the way to do business in Switzerland.`
        ],
        partnerUniversities: "6",
        partnerUniversitiesAdditionalInfos: true,
        bocconiJobsAbroad: "1",
        inCompanyTraining: "2",
        studentsExchanged: "40+",
        internshipPlacement: "190+",
        bocconiAlumni: "2,000+",
        links: [
          {
            title: "JobGate",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/meet+the+employers/find+your+opportunities/jobgate",
            description:
              "the Bocconi online platform, updated daily by employers, with internship and placement opportunities."
          },
          {
            title: "Bocconi&Jobs abroad",
            link: "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/meeting+employers+and+appllying/bocconi_jobs+abroad/digital+bocconiandjobs+abroad+germany",
            description:
              "the career event to meet international employers offering opportunities in Switzerland."
          },
          {
            title: "In-Company Training abroad",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/employment+guidance/in-company+training/in-company+training_new_mainetti+2010+11+03+03+29",
            description:
              "a short career program designed by Bocconi in partnership with selected companies and institutions."
          },
          {
            title: "One-to-One Advice on the International Job Market",
            link:
              "https://www.unibocconi.it/wps/wcm/connect/bocconi/sitopubblico_it/albero+di+navigazione/home/corsi+di+studio/studenti+iscritti/servizi/career+services/studenti+e+laureati/orientarsi+al+lavoro/one-to-one+advice+on+the+international+job+market",
            description: "personal guidance on the job market in Switzerland."
          },
          {
            title: "GoinGlobal",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/employment+guidance/onlineresources_infopoint",
            description:
              "over 3,000 pages with internship and job offers, company profiles, information about residence permits, details about jobs and salaries (only through your yoU@B)."
          },
          {
            title: "Lavoro.net",
            link:
              "https://www.unibocconi.it/wps/wcm/connect/bocconi/sitopubblico_it/albero+di+navigazione/home/corsi+di+studio/studenti+iscritti/servizi/career+services/studenti+e+laureati/orientarsi+al+lavoro/career+service+infopoint/online+resources/lavoro.net?lang=it",
            description: "a list of useful websites for your job search."
          },
          {
            title: "INTERNATIONAL SOS",
            link:
              "https://www.internationalsos.com/MasterPortal/default.aspx?content=messages&countryid=198",
            description: "travel safely in Switzerland."
          }
        ]
      },
      {
        name: "UK",
        id: "uk",
        coordinates: [55.378052, -3.435973],
        flag: "uk",
        videoUrl: "https://player.vimeo.com/video/344116135",
        legislature: "Constitutional monarchy",
        administrativeCenter: "London",
        gdpPerCapita: "USD 39,800",
        population: "66 million",
        workingIn: `<p>At the beginning of the 20th century, UK was an industrial nation, but over the last decades it has become less dependent on manufacturing and more on service-based industries. Banking, insurance and business services account by far for most of the GDP, and the service industry accounts for up to 84% of all jobs. This industry is - therefore - a key driver for growth. </p>
<p>Agriculture, on the other hand, is also intensive, highly mechanized and efficient by European standards, and a very limited number of workers produce a high percentage of the country’s food needs. The UK is also the largest producer of oil and gas in Europe.</p>
<p>According to Office for National Statistics, the top three industries in terms of employment are wholesale and retail trade, health care, and social work and professional, scientific and technical sectors. According to recent independent surveys, major areas of job development over the next three years will be data engineering, digital management, data science and information consultancy.</p>

`,
        workingLanguages: [],
        businessPractice: true,
        mainLanguage: `The British are usually on time, however a few minutes’ delay in a business meeting may occur without too much hassle and usually a 10-15 minute delay in social encounters is also accepted. On the other hand, deadlines are to be kept at all times and time management skills are considered essential at work. 
Meetings in the UK are orderly and efficient. Equality and anti-discrimination are increasingly important in work environments.  `,
        internationalCommunities: `The UK is a multicultural society, with 14% of the population making up different ethnic groups, according to the census. London is a true melting pot of different cultures and this is evident in most work environments.<br> 
History has shaped the UK and its multicultural traits and British cuisine is an example of this. However, the UK is renowned for a certain level of tradition, which translates in a strong sense of identity and national pride.
`,
        do: [
          `Shake hands when greeting someone.`,
          `Start and end a conversation with small talk. A good icebreaker may be a statement on the weather. It may sound
  like a cliché, but it is actually a common topic for locals, too.`,
          `Go to the pub if invited for drinks after work. It may have been a long day, but it is an essential part of social life
  with co-workers.`,
          `Ask for the proper dress code for an event you have been invited to.`
        ],
        donts: [
          `Don’t get offended if someone makes a joke during a business meeting. Wit is part of the British culture and
  sarcasm is often used in work situations.`,
          `Don’t be too direct. The British are very good at saying things without actually doing so.`,
          `Don’t ask personal or intimate questions (such as, “Where do you come from? How much do you earn? Do you have any kids?”).`,
          `Don’t jump the queue! The Brits are orderly and polite when queuing up.`
        ],
        partnerUniversities: "25",
        partnerUniversitiesAdditionalInfos: true,
        bocconiJobsAbroad: "1",
        inCompanyTraining: "8",
        studentsExchanged: "200+",
        internshipPlacement: "390+",
        bocconiAlumni: "4,900+",
        links: [
          {
            title: "JobGate",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/meet+the+employers/find+your+opportunities/jobgate",
            description:
              "the Bocconi online platform, updated daily by employers, with internship and placement opportunities."
          },
          {
            title: "Bocconi&Jobs abroad",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/meeting+employers+and+appllying/bocconi_jobs+abroad/digital+bocconiandjobs+abroad+uk+and+ireland,+26+october+2021",
            description:
              "the career event to meet international employers offering opportunities in the UK."
          },
          {
            title: "In-Company Training abroad",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/employment+guidance/in-company+training/in-company+training_new_mainetti+2010+11+03+03+29",
            description:
              "a short career program designed by Bocconi in partnership with selected companies and institutions."
          },
          {
            title: "One-to-One Advice on the International Job Market",
            link:
              "https://www.unibocconi.it/wps/wcm/connect/bocconi/sitopubblico_it/albero+di+navigazione/home/corsi+di+studio/studenti+iscritti/servizi/career+services/studenti+e+laureati/orientarsi+al+lavoro/one-to-one+advice+on+the+international+job+market",
            description: "personal guidance on the job market in the UK."
          },
          {
            title: "GoinGlobal",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/employment+guidance/onlineresources_infopoint",
            description:
              "over 3,000 pages with internship and job offers, company profiles, information about residence permits, details about jobs and salaries (only through your yoU@B)."
          },
          {
            title: "Lavoro.net",
            link:
              "https://www.unibocconi.it/wps/wcm/connect/bocconi/sitopubblico_it/albero+di+navigazione/home/corsi+di+studio/studenti+iscritti/servizi/career+services/studenti+e+laureati/orientarsi+al+lavoro/career+service+infopoint/online+resources/lavoro.net?lang=it",
            description: "a list of useful websites for your job search."
          },
          {
            title: "INTERNATIONAL SOS",
            link:
              "https://www.internationalsos.com/MasterPortal/default.aspx?content=messages&countryid=176",
            description: "travel safely in the UK."
          }
        ]
      }
    ]
  },
  {
    name: "Africa and Middle East",
    id: "africa-and-middle-east",
    flag: "ame",
    partnerUniversities: "16",
    doubleDegree: null,
    tripleDegree: null,
    studentsExchanged: "40~",
    internship: "100+",
    jobCount: "N/A",
    jobCities: "",
    alumni: "1,000~",
    futureinCompanyTraining: "2",

    states: [
      {
        name: "South Africa",
        id: "southafrica",
        coordinates: [-25.746019, 28.18712],
        flag: "sa",
        /* videoUrl: "https://vimeo.com/345876377/8c82e5504f", */
        videoUrl: "https://player.vimeo.com/video/345876377",
        legislature: "Republic",
        administrativeCenter: "Bloemfontein, Cape Town, Pretoria",
        gdpPerCapita: "USD 6,179",
        population: "56.5 million",
        workingLanguages: [],
        workingIn: `<p>South Africa’s economy has been traditionally based on the primary sector, given the mineral resources and the favorable agricultural conditions. Recent decades, however, have seen a significant change, and the economy has currently been driven mainly by the tertiary sector, which includes wholesale and retail trade, tourism and communications. South Africa is now becoming a knowledge-based economy, with a strong focus on technology, e-commerce and other services.</p>
<p>The country can also count on a well-developed and well-regulated banking system, which includes a Central Bank, several investment institutions and a few large and smaller private banks. It also has a large and active stock exchange, ranked 18th in the world. South Africa is also a fertile ground for entrepreneurial activities, as the government encourages the establishment of new businesses by foreigners.</p>`,
        mainLanguage: `The South African government recognizes 11 official languages, including <b>English</b>.<br>English is the mainly used working language and the dominant language for government and media communications, as it represents the second language for most South Africans.
`,
        internationalCommunities: `Despite the country high unemployment rate (approximately 25%), South Africa offers a good number of job opportunities for
  qualified and international profiles. Popular cities for expats are Johannesburg and Cape Town. While “Jo'burg” is renowned
  for its “play hard, work hard” culture, Cape Town is known for a more balanced, relaxed lifestyle. A recent survey reveals that
  South Africa-based expats mostly feel that the change was worth it, with 68% reporting being satisfied with their move and
  their career prospects. These percentages are higher in South Africa than in most countries, as a result of the warmth, the
  engagement and the hospitality of the locals.`,
        do: [
          `Show respect to the elderly, as they are held in high regard in the South African culture.`,
          `Leave a bigger timeframe for things to get done than you would overseas, and remember that “just now” doesn’t
  necessarily mean “this instant” for South Africans.`,
          `Speak and write in a very direct, honest way. Any ambiguity or vagueness on your behalf may be interpreted as a sign of
  untrustworthiness, dishonesty or lack of commitment.`,
          `Try to obtain introductions from a mutual contact in order to begin a business or professional relationship, as trust is
  often an issue in South Africa.`
        ],
        donts: [
          `Don’t mention politics, racism, the Apartheid, violence or similar issues. South Africans can become touchy about
  these issues, as the turbulent history of the country is a sensitive subject.`,
          `Don’t act surprised if a colleague pats you on the back, shakes your hand, or even holds your hand. South Africans are
  very friendly and may express affection openly.`,
          `Don’t raise your voice and always keep a mild tone when conversing at work: South Africans want to maintain
  harmonious working relationships and avoid confrontations.`,
          `Don’t expect to get things done on short notice without exercising some pressure.`
        ],
        partnerUniversities: "4",
        studentsExchanged: "10",
        internshipPlacement: "60+",
        bocconiAlumni: "30~",
        links: [
          {
            title:
              "JobGate > Focus on Companies in Asia-Pacific and Africa",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/meet+the+employers/find+your+opportunities/jobgate",
            description:
              "the Bocconi online platform, updated daily by employers, with internship and placement opportunities."
          },
          {
            title: "One-to-One Advice on the International Job Market",
            link:
              "https://www.unibocconi.it/wps/wcm/connect/bocconi/sitopubblico_it/albero+di+navigazione/home/corsi+di+studio/studenti+iscritti/servizi/career+services/studenti+e+laureati/orientarsi+al+lavoro/one-to-one+advice+on+the+international+job+market",
            description: "personal guidance on the job market in Africa."
          },
          {
            title: "GoinGlobal",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/employment+guidance/onlineresources_infopoint",
            description:
              "over 3,000 pages with internship and job offers, company profiles, information about residence permits, details about jobs and salaries (only through your yoU@B)."
          },
          {
            title: "Lavoro.net",
            link:
              "https://www.unibocconi.it/wps/wcm/connect/bocconi/sitopubblico_it/albero+di+navigazione/home/corsi+di+studio/studenti+iscritti/servizi/career+services/studenti+e+laureati/orientarsi+al+lavoro/career+service+infopoint/online+resources/lavoro.net?lang=it",
            description: "a list of useful websites for your job search."
          },
          {
            title: "INTERNATIONAL SOS",
            link:
              "https://www.internationalsos.com/MasterPortal/default.aspx?content=messages&countryid=11",
            description: "travel safely in South Africa."
          }
        ]
      },
      {
        name: "UAE",
        id: "uae",
        coordinates: [23.424076, 53.847816],
        flag: "uae",
        videoUrl: "https://player.vimeo.com/video/344116654",
        legislature: "Absolute monarchy",
        administrativeCenter: "Abu Dhabi",
        gdpPerCapita: "USD 37,732",
        population: "10.1 million",
        workingIn: `<p>The country is known for being one of the world’s major oil producers; however, starting from the 1990s, the UAE government has pushed for a more diversified economy. Thanks to national and international capital investments and to its strategic geopolitical position - acting as a bridge between the Middle East and the Far East - the UAE now hosts the regional HQs of important multinational companies. </p>
<p>Dubai is the city where most company offices are based, while Abu Dhabi gathers the main national institutions. Dubai is also interesting for startups: there are more than 30 Free Zones operating in town, which are special economic zones set up to offer tax concessions and customs duty benefits to expat investors. The following are the most popular: DAFZA (Dubai Airport Free Zone Authority), DDD (Dubai Design District), DIC (Dubai Internet City), DIFC (Dubai International Financial Center), DMC (Dubai Media City), JAFZA (Jebel Ali Free Zone Authority). Between October 2020 and April 2021, Dubai will host Expo 2020, with more than 180 nations exhibiting and a potential international audience of 25 million visitors.</p>`,
        workingLanguages: ["Arabic"],
        mainLanguage: "<b>English</b> is widely used in professional settings.",
        internationalCommunities: `There are more than 200 nationalities living and working in the UAE. The expatriate community heavily outnumbers the population of UAE nationals: immigrants are about 90% of the population. As you will meet people from the five Continents on a daily basis, sensitivity towards different cultures, religions and traditions is mandatory to perform appropriately in the office and during social occasions.`,
        do: [
          `When in a meeting, it is important to stand up for new guests and older or higher-ranking people. Men are also
  expected to stand when a woman enters the room.`,
          `Dubai is all about in-person networking events: participate, enjoy and keep in touch afterwards (with a business card
  printed in Arabic on one side is better!)`,
          `Men and women should always dress modestly: a business casual attire is right in the office, as well as on social occasions.`
        ],
        donts: [
          `Don’t shake hands when greeting a member of the opposite sex, unless they extend their hand first.`,
          `Don’t dive too quickly into business matters: if you’re sharing a meal with a host, accept food and
  refreshments before moving the conversation forward. When it’s time to talk business, your host will bring it up.`,
          `Don’t point with your finger, as this is considered impolite.`
        ],
        partnerUniversities: "1",
        inCompanyTraining: "2",

        studentsExchanged: "2",
        internshipPlacement: "20+",
        bocconiAlumni: "320+",
        partnerUniversitiesAdditionalInfos: true,
        links: [
          {
            title:
              "JobGate",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/meet+the+employers/find+your+opportunities/jobgate",
            description:
              "the Bocconi online platform, updated daily by employers, with internship and placement opportunities."
          },
          {
            title: "In-Company Training abroad",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/employment+guidance/in-company+training/in-company+training_new_mainetti+2010+11+03+03+29",
            description:
              "a short career program designed by Bocconi in partnership with selected companies and institutions."
          },
          {
            title: "One-to-One Advice on the International Job Market",
            link:
              "https://www.unibocconi.it/wps/wcm/connect/bocconi/sitopubblico_it/albero+di+navigazione/home/corsi+di+studio/studenti+iscritti/servizi/career+services/studenti+e+laureati/orientarsi+al+lavoro/one-to-one+advice+on+the+international+job+market",
            description: "personal guidance on the job market in the UAE."
          },
          {
            title: "GoinGlobal",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/employment+guidance/onlineresources_infopoint",
            description:
              "over 3,000 pages with internship and job offers, company profiles, information about residence permits, details about jobs and salaries (only through your yoU@B)."
          },
          {
            title: "Lavoro.net",
            link:
              "https://www.unibocconi.it/wps/wcm/connect/bocconi/sitopubblico_it/albero+di+navigazione/home/corsi+di+studio/studenti+iscritti/servizi/career+services/studenti+e+laureati/orientarsi+al+lavoro/career+service+infopoint/online+resources/lavoro.net?lang=it",
            description: "a list of useful websites for your job search."
          },
          {
            title: "INTERNATIONAL SOS",
            link:
              "https://www.internationalsos.com/MasterPortal/default.aspx?content=messages&countryid=160",
            description: "travel safely in UAE."
          }
        ]
      },

      {
        name: "Uganda",
        id: "uganda",
        coordinates: [1.373333, 32.290276],
        flag: "uganda",
        /* videoUrl: "https://vimeo.com/345876507/098c14240e", */
        videoUrl: "https://player.vimeo.com/video/345876507",
        legislature: "Republic",
        administrativeCenter: "Kampala",
        gdpPerCapita: "USD 706",
        population: "37.7 million",
        workingIn: `<p>The economy of Uganda benefits significantly from its rich resources. Thanks to its fertile land and regular rainfall, it is believed that Uganda could feed the whole African population if all its farmland were cultivated. Uganda can also count on rich mineral resources, including gold, copper and recently discovered oil reserves. Thanks to its growing economy and investment-friendly policies, the country is attracting relevant foreign investments from oil and gas international groups.</p>
<p>Even if Uganda’s economy has been traditionally based on the primary sector, the economic landscape of the capital city Kampala has moved to a more service-based industry, with a focus on financial services, tourism and communication.</p>
<p>Uganda is a pioneer in the liberalization of media in Africa, and it currently boasts nearly 200 private radio stations and dozens of television stations and print media outlets. Uganda is also an important center for humanitarian and international cooperation organizations, with thousands of NGOs present in the country.</p>
`,
        workingLanguages: [],
        mainLanguage: `Uganda counts more than 40 different spoken languages.<br><b>English</b> is the official working language used for all formal communications, while Swahili and Luganda are used for inter-ethnic communication.

`,
        internationalCommunities: `Uganda boasts a vivid, welcoming and diverse international community, primarily based in the capital Kampala. Set on the
  edge of Lake Victoria, the world’s second largest freshwater lake, Kampala is known across the region for its nightlife and its
  great range of clubs, activities and restaurants. Even if most expats are professionals working for International Organizations
  and NGOs, journalists and diplomats, the city economic growth keeps attracting professionals from the private sector.`,
        do: [
          `Take time to build a relationship before talking business. Ugandans are very relationship-oriented both in social and
  business environments, and enjoy taking the time to get to know you.`,
          `Respect the hierarchy: the highest-ranking people take final decisions. There is also a very clear distinction between management and staff, and those with a higher rank will openly demonstrate this.`,
          `Greet both men and women with a handshake. If you are a man, be aware that when greeting a Ugandan woman it is best
  to wait until she extends her hand.`,
          `Dress appropriately in order to be more respected: men wear neatly pressed suits and women will usually be very well
  groomed. Making an effort without being ostentatious gives the right impression.`
        ],
        donts: [
          `Don’t discuss politics, religion, tribal systems, polygamy, and homosexuality, as they are sensitive subjects.`,
          `Don’t lose your temper if things don’t happen in time as per your plans. The concept of time is different in Uganda.`,
          `Don’t be surprised if your Ugandan colleagues stand very close to you. Their personal space is
  smaller than in Western countries. It is also common to see men touching or holding hands in public.`,
          `Don’t be surprised if a colleague answers the phone in the middle of a meeting just to avoid calling back. Mobile credit,
  known as “airtime” is a highly prized commodity.`
        ],
        hideBocconiAndCountry: true,
        links: [
          {
            title:
              "JobGate > Focus on Companies in Asia-Pacific and Africa",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/meet+the+employers/find+your+opportunities/jobgate",
            description:
              "the Bocconi online platform, updated daily by employers, with internship and placement opportunities."
          },
          {
            title: "One-to-One Advice on the International Job Market",
            link:
              "https://www.unibocconi.it/wps/wcm/connect/bocconi/sitopubblico_it/albero+di+navigazione/home/corsi+di+studio/studenti+iscritti/servizi/career+services/studenti+e+laureati/orientarsi+al+lavoro/one-to-one+advice+on+the+international+job+market",
            description: "personal guidance on the job market in Africa."
          },
          {
            title: "GoinGlobal",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/employment+guidance/onlineresources_infopoint",
            description:
              "over 3,000 pages with internship and job offers, company profiles, information about residence permits, details about jobs and salaries (only through your yoU@B)."
          },
          {
            title: "Lavoro.net",
            link:
              "https://www.unibocconi.it/wps/wcm/connect/bocconi/sitopubblico_it/albero+di+navigazione/home/corsi+di+studio/studenti+iscritti/servizi/career+services/studenti+e+laureati/orientarsi+al+lavoro/career+service+infopoint/online+resources/lavoro.net?lang=it",
            description: "a list of useful websites for your job search."
          },
          {
            title: "INTERNATIONAL SOS",
            link:
              "https://www.internationalsos.com/MasterPortal/default.aspx?content=messages&countryid=87",
            description: "travel safely in Uganda."
          }
        ]
      }
    ]
  },
  {
    name: "Americas",
    id: "americas",
    flag: "eu",
    partnerUniversities: "92",
    partnerUniversitiesAdditionalInfos: true,
    doubleDegree: "9",
    tripleDegree: "1",
    studentsExchanged: "700+",
    internship: "85+",
    jobCount: "N/A",
    jobCities: "",
    inCompanyTraining: "2",
    alumni: "3,000+",
    states: [
      {
        name: "Brazil",
        id: "brazil",
        coordinates: [-23.533773, -46.62529],
        flag: "brazil",
        videoUrl: "https://player.vimeo.com/video/344116301",
        legislature: "Republic",
        administrativeCenter: "Brasilia",
        gdpPerCapita: "USD 9,895",
        population: "207.7 million",
        workingIn: `
          <p>According to the last OECD Economic Survey, over the past two decades, strong growth combined with remarkable social progress have made Brazil one of the world’s leading economies.</p><p>Brazil is one of the world giants of mining, agriculture, and manufacturing, and it has a strong and rapidly growing service sector. Most industrial minerals are concentrated in Minas Gerais and Pará, including iron ore, bauxite, and gold. Mato Grosso and Amapá have most of the known manganese deposits.</p><p>The industrial sector is mainly located in the states of SãoPaulo, Minas Gerais and Rio de Janeiro. Major industries include: iron and steel production, automobile assembly, petroleum processing, chemicals production, and cement making; technologically based industries have been the most dynamic in recent years, but have not outpaced traditional industries. Agriculture is instead a predominant sector of the Northern and Southern states and the country is the world’s primary source of coffee, oranges, and cassava and a major producer of soybeans.</p>
        `,
        mainLanguage: `<b>Portuguese</b> is the official and the working language.`,
        internationalCommunities: `Brazil continues to be a center of global migration. In 2017, nearly 730,000 registered immigrants lived in Brazil. Portuguese are the largest immigrant population, followed far behind by those from Japan (Brazil hosts the largest community of Japanese outside Japan), Italy, Paraguay, and Bolivia. In recent years, Koreans, Angolans, Paraguayans, and Nigerians have been entering in growing numbers.`,
        do: [
          `Physical contact is part of the communication. Touching arms, elbows and backs is very common and acceptable. `,
          `Try to make appointments between 10 and 12 AM, so that your business meeting runs into lunch; a good meal is key to building a relationship.`,
          `Always maintain eye contact; it is impolite to stop eye contact while speaking to a Brazilian.`
        ],
        donts: [
          `Don’t do the "okay” gesture (a circle of first finger and thumb), as it is considered vulgar and unacceptable in Brazil.`,
          `Don’t show feelings of impatience: the pace of negotiations may be slow. Developing a personal relationship is important.`,
          `Don’t discuss business during a meal. Such discussions will only begin after coffee is served.`
        ],
        partnerUniversities: "5",
        partnerUniversitiesAdditionalInfos: true,
        studentsExchanged: "50+",
        bocconiAlumni: "250+",
        links: [
          {
            title: "JobGate > Focus on Companies in Americas",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/meet+the+employers/find+your+opportunities/jobgate",
            description:
              "the Bocconi online platform, updated daily by employers, with internship and placement opportunities."
          },
          {
            title: "One-to-One Advice on the International Job Market",
            link:
              "https://www.unibocconi.it/wps/wcm/connect/bocconi/sitopubblico_it/albero+di+navigazione/home/corsi+di+studio/studenti+iscritti/servizi/career+services/studenti+e+laureati/orientarsi+al+lavoro/one-to-one+advice+on+the+international+job+market",
            description: "personal guidance on the job market in Brazil."
          },
          {
            title: "GoinGlobal",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/employment+guidance/onlineresources_infopoint",
            description:
              "over 3,000 pages with internship and job offers, company profiles, information about residence permits, details about jobs and salaries (only through your yoU@B)."
          },
          {
            title: "Lavoro.net",
            link:
              "https://www.unibocconi.it/wps/wcm/connect/bocconi/sitopubblico_it/albero+di+navigazione/home/corsi+di+studio/studenti+iscritti/servizi/career+services/studenti+e+laureati/orientarsi+al+lavoro/career+service+infopoint/online+resources/lavoro.net?lang=it",
            description: "a list of useful websites for your job search."
          },
          {
            title: "INTERNATIONAL SOS",
            link:
              "https://www.internationalsos.com/MasterPortal/default.aspx?content=messages&countryid=27",
            description: "travel Safely in Brazil."
          }
        ]
      },
      {
        name: "USA",
        id: "usa",
        coordinates: [40.884514, -73.419167],
        flag: "usa",
        videoUrl: "https://player.vimeo.com/video/344116405",
        legislature: "Republic",
        administrativeCenter: "Washington, D.C.",
        gdpPerCapita: "USD 59,792",
        population: "325.9 million",
        workingIn: `
          <p>When it comes to economic performance, there are few countries that can be compared to the United States. The US represents the world’s largest economy and its current expansion is now the longest on record. The US economy is well diversified among all sectors: despite being a service-based economy, it ranks second in terms of industrial output and boasts the most influential financial market in the world.</p><p>New York is the leading hub, offering countless opportunities, ranging from the financial sector to fashion companies, from international affairs to the tech industry. Although San Francisco and Silicon Valley remain one of the major technology centers, New York is playing an increasingly important role in innovation. The NYC government has been - in fact - very proactive with incentive programs to foster startups, tech incubators and entrepreneurial talents.</p><p>Los Angeles and Miami are, instead, the places to be for those interested in pursuing a career in the art and entertainment sectors, as they are home of legendary film production companies and host some of the most renowned art fairs and events.</p>
        `,
        businessPractice: true,
        mainLanguage: `The American workplace tends to be less formal than others, and there is no apparent hierarchy. Employers are usually treated equally and everybody’s input, suggestions and objections are always welcomed and often encouraged. Business executives speak directly, as straightforward and get-to-the-point communication is preferred. Also, Americans highly appreciate the individual initiative and a “do-it-yourself” mentality.`,
        internationalCommunities: `
According to the US Census, the US will become “minority white” in 2045. The US foreign-born population reached a record 44.4 million in 2017, accounting for more than 13% of the total population. Mexico and South-East Asia are the top origin regions, accounting together for more than half of the US foreign population. Other regions make up smaller shares: Europe/Canada (13%), the Caribbean (10%), Central America (8%), South America (7%), the Middle East (4%) and Sub-Saharan Africa (4%).

               `,
        do: [
          `Participate in corporate social life. Most companies have social initiatives: cooperating with these company practices is held in high esteem. `,
          `Work quickly and efficiently. The belief that “time is money” is widespread and good time management is deemed essential.`,
          `Be on time: punctuality is very important on business occasions. Tardiness is a sign of disrespect.`,
          `Dress neatly and conservatively.`
        ],
        donts: [
          `Don’t be shy. During meetings, participants’ thoughts and opinions are welcomed and encouraged. `,
          `Don’t be surprised if your boss is very young, or if your co-workers are diverse in terms of race, gender, religion or sexual orientation. America is quite varied and this is one of its strengths.`,
          `Don’t use greetings that involve close physical contact. Americans don’t like to be touched or stand too close.`,
          `Don’t’ be surprised if your colleagues seldom take breaks during the day. Working hard is a trademark of US society.`
        ],
        partnerUniversities: "57",
        partnerUniversitiesAdditionalInfos: true,
        studentsExchanged: "480+",
        internshipPlacement: "70+",
        inCompanyTraining: "2",
        bocconiAlumni: "2,200+",
        links: [
          {
            title: "JobGate > Focus on Companies in Americas",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/meet+the+employers/find+your+opportunities/jobgate",
            description:
              "the Bocconi online platform, updated daily by employers, with internship and placement opportunities."
          },
          {
            title: "In-Company Training abroad",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/employment+guidance/in-company+training/in-company+training_new_mainetti+2010+11+03+03+29",
            description:
              "a short career program designed by Bocconi in partnership with selected companies and institutions."
          },
          {
            title: "One-to-One Advice on the International Job Market",
            link:
              "https://www.unibocconi.it/wps/wcm/connect/bocconi/sitopubblico_it/albero+di+navigazione/home/corsi+di+studio/studenti+iscritti/servizi/career+services/studenti+e+laureati/orientarsi+al+lavoro/one-to-one+advice+on+the+international+job+market",
            description: "personal guidance on the job market in the US."
          },
          {
            title: "GoinGlobal",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/employment+guidance/onlineresources_infopoint",
            description:
              "over 3,000 pages with internship and job offers, company profiles, information about residence permits, details about jobs and salaries (only through your yoU@B)."
          },
          {
            title: "Lavoro.net",
            link:
              "https://www.unibocconi.it/wps/wcm/connect/bocconi/sitopubblico_it/albero+di+navigazione/home/corsi+di+studio/studenti+iscritti/servizi/career+services/studenti+e+laureati/orientarsi+al+lavoro/career+service+infopoint/online+resources/lavoro.net?lang=it",
            description: "a list of useful websites for your job search."
          },
          {
            title: "INTERNATIONAL SOS",
            link:
              "https://www.internationalsos.com/MasterPortal/default.aspx?content=messages&countryid=111",
            description: "travel Safely in the US."
          }
        ]
      }
    ]
  },
  {
    name: "Asia-Pacific",
    id: "asia pacific",
    flag: "eu",
    partnerUniversities: "63",
    doubleDegree: "8",
    tripleDegree: "1",
    studentsExchanged: "500~",
    internship: "160+",
    jobCount: "1",
    jobCities: "China&Hong Kong",
    alumni: "1,700+",
    states: [
      {
        name: "Australia",
        id: "australia",
        flag: "australia",
        coordinates: [-25.2743988, 133.7751312],
        videoUrl: "https://vimeo.com/344115747/2ab434c754",
        legislature: "Constitutional Monarchy",
        administrativeCenter: "Canberra",
        gdpPerCapita: "USD 55,692",
        population: "24.8 million",
        workingIn: `
               <p>The Australian economy has undergone many structural changes over time. One of the most important has been the transition from a good-producing economy to a more service-oriented one. The service industry nowadays accounts for over 70% of the GDP and engages several industries, such as tourism, media, entertainment, healthcare, logistics, education, and finance.</p><p>Thanks to its modern financial sector and its strong economic performance, Australia is considered a preferred place to do business and a global commercial hub. In 2015, the World Bank ranked Australia as the fastest place to start a business. The main reasons why Australia is considered a business destination are its political and economic stability, its multicultural manpower coming from all corners of the world, the high quality of life, advantageous trade agreements with different countries and the presence of small businesses (96%), which also means that there are fewer risks to be squeezed by giant companies.</p>
               `,
        businessPractice: true,
        mainLanguage: `Colleagues usually spend lots of time together after work, and this does not necessary happen only on Fridays. 
Aussies are very friendly, and it is pretty normal to approach someone for a chat in the workplace. You should not be late for meetings (it is inadmissible), but being early is not recommended either. Australian lunch meetings are relaxed, and it is normal to start them with small talk.`,
        internationalCommunities: `“Down Under” is, by nature, deeply multicultural: Australians come from over 200 birthplaces and speak over 200 languages. Around 26% of the population was born in another country. Of the oversea-born population, most come from England, New Zealand, China and India, while 19% was born in non-English speaking countries. `,
        do: [
          `Present your business card upon meeting. No formal ritual is required.`,
          `Handshakes are an appropriate way of greeting both men and women.`,
          `A dark-colored, conservative business suit is considered suitable for men. Women can wear a smart dress or a business suit.`
        ],
        donts: [
          `Don't be late: punctuality is very important. Call with an explanation if you are late.`,
          `Don’t start your workday too late: Australians usually get to work early in the morning (around 8:30).`,
          `Don’t say “no” to extra work: even when their schedules are already full, Australians will generally say “no worries” and make the time.`
        ],
        partnerUniversities: "11",
        partnerUniversitiesAdditionalInfos: true,
        studentsExchanged: "90+",
        internshipPlacement: "10+",
        jobCount: "N/A",
        jobCities: "",
        bocconiAlumni: "140+",
        links: [
          {
            title:
              "JobGate > Focus on Companies in Asia-Pacific and Africa",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/meet+the+employers/find+your+opportunities/jobgate",
            description:
              "the Bocconi online platform, updated daily by employers, with internship and placement opportunities."
          },
          {
            title: "One-to-One Advice on the International Job Market",
            link:
              "https://www.unibocconi.it/wps/wcm/connect/bocconi/sitopubblico_it/albero+di+navigazione/home/corsi+di+studio/studenti+iscritti/servizi/career+services/studenti+e+laureati/orientarsi+al+lavoro/one-to-one+advice+on+the+international+job+market",
            description: "personal guidance on the job market in Australia."
          },
          {
            title: "GoinGlobal",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/employment+guidance/onlineresources_infopoint",
            description:
              "over 3,000 pages with internship and job offers, company profiles, information about residence permits, details about jobs and salaries (only through your yoU@B)."
          },
          {
            title: "Lavoro.net",
            link:
              "https://www.unibocconi.it/wps/wcm/connect/bocconi/sitopubblico_it/albero+di+navigazione/home/corsi+di+studio/studenti+iscritti/servizi/career+services/studenti+e+laureati/orientarsi+al+lavoro/career+service+infopoint/online+resources/lavoro.net?lang=it",
            description: "a list of useful websites for your job search."
          },
          {
            title: "INTERNATIONAL SOS",
            link:
              "https://www.internationalsos.com/MasterPortal/default.aspx?content=messages&countryid=103",
            description: "travel safely in Australia."
          }
        ]
      },
      {
        name: "China and Hong Kong",
        id: "china-and-hong-kong",
        disabled: true,
        coordinates: [22.286394, 114.149139],
        flag: "chinaAndHongKong",
        videoUrl: "https://vimeo.com/344115919/6a6d941b1f",
        legislature: "Republic",
        administrativeCenter: "Beijing",
        gdpPerCapita: "USD 8,643 (China); USD 46,080 (Hong Kong)",
        population: "1.4 billion",
        workingIn: `
<p>Hong Kong is an international and cosmopolitan city, known for its strategic position, business-friendly environment, rule of law and free trade. Hong Kong is an international financial centre, with one of the most relevant stock markets worldwide in terms of market capitalization. At the same time, Hong Kong is China’s largest trading partner and provides a wide range of business support services, such as banking and finance, insurance, transport, accounting and legal ones.</p><p>On the other hand, China is the world’s second-biggest economy, contributing to about a quarter of global growth. Services and consumptions represent some of the fastest growing sectors, while digitalization provides a leapfrogging opportunity for Chinese firms. The country has become a world  leader in  e-commerce,  online payments and sharing economy. The top 10 Chinese cities are: Beijing, Shanghai, Guangzhou, Shenzhen, Hangzhou, Chengdu, Wuhan, Xiamen and Nanjing. Bear in mind that only Chinese citizens are eligible for an internship in China.</p>
`,
        mainLanguage: `<b>Chinese</b> and <b>English</b> are the official and the working languages in Hong Kong.<br><b>Chinese</b> is the official and the working language in China.`,

        internationalCommunities: `
<p>A hardworking, entrepreneurial and well-educated population of more than 7.4 million, predominantly of Chinese ethnicity, forms the foundation of Hong Kong’s productivity and creativity. Over half of the non-Chinese population in Hong Kong are Filipinos and Indonesians, whereas the two most represented nationalities within the expatriate community are French and British. The fact that many Chinese living in Hong Kong understand and speak English, due to Hong Kong’s colonial past, further contributes to the city’s international feel.</p><p>Last decade of China’s rapid economic growth has attracted a large number of expatriates from various countries. The largest foreign communities in China are South Koreans, Japanese and Americans. Among European nationalities, most foreigners are from France, Germany and the UK.</p>
               `,
        do: [
          `Exchange business cards with each individual and present it with both hands. Study the cards received for a while and leave it on the table. `,
          `Greet others by shaking hands or nodding, save the bows for your visit to Japan!`,
          `When meeting Chinese business people, always address them starting from most senior person and by their professional titles and family name.  `
        ],
        donts: [
          `Don’t get too sensitive if asked personal questions by a Chinese colleague. Questions regarding your marital status or income can be used as an icebreaker in business contexts.`,
          `Don’t point at someone with one finger, motion with the palm of your hand instead.`,
          `Don’t create situations that can cause embarrassment to you and others: “saving face” is a fundamental concept in Chinese culture.`
        ],
        partnerUniversities: "19",
        partnerUniversitiesAdditionalInfos: true,
        studentsExchanged: "180+",
        internshipPlacement: "65+",
        bocconiJobsAbroad: "1",
        inCompanyTraining: "4",
        bocconiAlumni: "800+",
        links: [
          {
            title:
              "JobGate > Focus on Companies in Asia-Pacific and Africa",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/meet+the+employers/find+your+opportunities/jobgate",
            description:
              "the Bocconi online platform, updated daily by employers, with internship and placement opportunities."
          },
          {
            title: "Bocconi&Jobs abroad in Shanghai",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/Bocconi/SitoPubblico_EN/Navigation+Tree/Home/Programs/Current+Students/Services/Career+Services/Students+and+Graduates/Meet+the+Employers/Bocconi_Jobs/Bocconi_Jobs+abroad+Shanghai/",
            description:
              "the career event to meet international employers offering opportunities in China."
          },
          {
            title: "In-Company Training abroad",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/employment+guidance/in-company+training/in-company+training_new_mainetti+2010+11+03+03+29",
            description:
              "a short career program designed by Bocconi in partnership with selected companies and institutions."
          },
          {
            title: "One-to-One Advice on the International Job Market",
            link:
              "https://www.unibocconi.it/wps/wcm/connect/bocconi/sitopubblico_it/albero+di+navigazione/home/corsi+di+studio/studenti+iscritti/servizi/career+services/studenti+e+laureati/orientarsi+al+lavoro/one-to-one+advice+on+the+international+job+market",
            description:
              "personal guidance on the job market in Hong Kong and China."
          },
          {
            title: "GoinGlobal",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/employment+guidance/onlineresources_infopoint",
            description:
              "over 3,000 pages with internship and job offers, company profiles, information about residence permits, details about jobs and salaries (only through your yoU@B)."
          },
          {
            title: "Lavoro.net",
            link:
              "https://www.unibocconi.it/wps/wcm/connect/bocconi/sitopubblico_it/albero+di+navigazione/home/corsi+di+studio/studenti+iscritti/servizi/career+services/studenti+e+laureati/orientarsi+al+lavoro/career+service+infopoint/online+resources/lavoro.net?lang=it",
            description: "a list of useful websites for your job search."
          },
          {
            title: "INTERNATIONAL SOS",
            link:
              "https://www.internationalsos.com/MasterPortal/default.aspx?content=messages&countryid=56",
            description: "travel Safely in China and Hong Kong"
          }
        ]
      },
      {
        name: "Singapore",
        id: "singapore",
        coordinates: [1.29027, 103.851959],
        flag: "singapore",
        videoUrl: "https://vimeo.com/347463337/969471a424",
        legislature: "Republic",
        administrativeCenter: "Singapore",
        gdpPerCapita: "USD 57,713",
        population: "5.6 million",
        workingIn: `
        <p>Singapore is one of the wealthiest countries in the world. It has established itself in the past decades as Southeast Asia's financial and technology hub, and its port is one of the busiest worldwide in terms of tonnage handled every year. The country has attracted major investments, especially in the biomedical field, but still depends quite heavily on exports, in particular of IT products and pharmaceuticals.</p><p>Singapore is one of the world’s most business-friendly environments for entrepreneurs, and is ranked among the world’s most competitive economies, also thanks to its stability, security and modern business culture. In the past few years the country has become a renowned hub for innovative digital services throughout the region.</p><p>The local business community reflects the fusion of Eastern and Western cultures, and the country hosts all kinds of ventures: from traditional Chinese businesses to multinational corporations and leading financial institutions that usually establish their APAC headquarters in the “Lion city”.</p>

`,
        mainLanguage: `<b>English</b>, <b>Malay</b>, <b>Mandarin</b> and <b>Tamil</b> are the official languages.<br><b>English</b> is the working language.`,

        internationalCommunities: `
               Singapore is a multicultural nation and represents a good mix between Easter and Western cultures. Over 70% of the local population is of Chinese heritage, but there are a significant number of Indian and Malay descendants, as well as Europeans and expatriates from all over the globe.
               `,
        do: [
          `Offer and receive business cards with two hands; business cards should be handed out to every person you meet.`,

          `Be calm and keep a low tone of voice even during the toughest negotiations, as it is very important for Singaporeans to “save face” in public.`,

          `Be on time! As public transport is extremely efficient and traffic is predictable, being late is particularly frowned upon.  `
        ],
        donts: [
          `Don’t openly criticize colleagues, bosses or clients: providing unsolicited opinions or comments is not acceptable for the local culture.`,
          `Don’t discuss politics, race or religion; keep small talk safe and talk about food, it is the local topic of choice!  `,
          `Don’t open a gift in front of the giver. Unwrap it later once you get home.`
        ],
        partnerUniversities: "4",
        partnerUniversitiesAdditionalInfos: true,
        studentsExchanged: "80+",
        internshipPlacement: "15+",
        bocconiAlumni: "130+",
        links: [
          {
            title:
              "JobGate > Focus on Companies in Asia-Pacific and Africa",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/meet+the+employers/find+your+opportunities/jobgate",
            description:
              "the Bocconi online platform, updated daily by employers, with internship and placement opportunities."
          },
          {
            title: "One-to-One Advice on the International Job Market",
            link:
              "https://www.unibocconi.it/wps/wcm/connect/bocconi/sitopubblico_it/albero+di+navigazione/home/corsi+di+studio/studenti+iscritti/servizi/career+services/studenti+e+laureati/orientarsi+al+lavoro/one-to-one+advice+on+the+international+job+market",
            description: "personal guidance on the job market in Singapore."
          },
          {
            title: "GoinGlobal",
            link:
              "https://www.unibocconi.eu/wps/wcm/connect/bocconi/sitopubblico_en/navigation+tree/home/programs/current+students/services/career+services/students+and+graduates/employment+guidance/onlineresources_infopoint",
            description:
              "over 3,000 pages with internship and job offers, company profiles, information about residence permits, details about jobs and salaries (only through your yoU@B)."
          },
          {
            title: "Lavoro.net",
            link:
              "https://www.unibocconi.it/wps/wcm/connect/bocconi/sitopubblico_it/albero+di+navigazione/home/corsi+di+studio/studenti+iscritti/servizi/career+services/studenti+e+laureati/orientarsi+al+lavoro/career+service+infopoint/online+resources/lavoro.net?lang=it",
            description: "a list of useful websites for your job search."
          },
          {
            title: "INTERNATIONAL SOS",
            link:
              "https://www.internationalsos.com/MasterPortal/default.aspx?content=messages&countryid=103",
            description: "travel Safely in Singapore."
          }
        ]
      }
    ]
  }
];
